(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-hamper-builder"] && !Shopify.designMode) return;
  try {
    
  class GiftHamperBuilder extends HTMLElement {
    connectedCallback() {
      this.size = parseInt(this.dataset.hamperSize, 10) || 3;
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.products = new Map();
      this.querySelectorAll('.hb-card').forEach((card) => {
        const data = JSON.parse(card.querySelector('[data-product-json]').textContent);
        data.sizeIndex = data.options.indexOf(this.strings.optionName);
        this.products.set(String(data.id), { data, card });
      });
      this.selection = [];
      this.submitting = false;
      this.hamperId = '';

      this.addEventListener('change', (evt) => {
        if (evt.target.matches('[data-gift-box]')) {
          this.render();
          return;
        }
        if (!evt.target.matches('.hb-card .hb-size input')) return;
        const productId = evt.target.closest('.hb-card').dataset.productId;
        const item = this.selection.find((entry) => entry.productId === productId);
        const variant = item && this.selectedVariant(this.products.get(productId));
        if (variant) {
          item.variant = variant;
          item.value = evt.target.value;
        }
        this.render();
      });
      this.setupCycling();
      this.setupPreview();
      this.addEventListener('click', (evt) => {
        const preview = evt.target.closest('[data-preview]');
        if (preview && !(evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey)) {
          evt.preventDefault();
          this.openPreview(preview.closest('.hb-card').dataset.productId);
          return;
        }
        const add = evt.target.closest('[data-add]');
        if (add) this.toggle(add.closest('.hb-card').dataset.productId);
        const remove = evt.target.closest('[data-remove]');
        if (remove) this.remove(remove.dataset.remove, true);
        if (evt.target.closest('[data-submit]')) this.submit();
      });
      this.render();
    }

    format(text, values) {
      return Object.entries(values).reduce((out, [key, value]) => out.split(`[${key}]`).join(value), text);
    }

    formatMoney(cents) {
      const format = this.dataset.moneyFormat || '';
      const withDelimiters = (precision, thousands = ',', decimal = '.') => {
        const [whole, fraction] = (cents / 100).toFixed(precision).split('.');
        return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
      };
      if (!format) return withDelimiters(2);
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => ({
        amount: withDelimiters(2),
        amount_no_decimals: withDelimiters(0),
        amount_with_comma_separator: withDelimiters(2, '.', ','),
        amount_no_decimals_with_comma_separator: withDelimiters(0, '.'),
        amount_with_apostrophe_separator: withDelimiters(2, "'"),
        amount_with_space_separator: withDelimiters(2, ' ', ',')
      })[key] ?? withDelimiters(2));
    }

    selectedVariant(product) {
      const checked = product.card.querySelector('.hb-size input:checked');
      if (product.data.sizeIndex === -1) return product.data.variants.find((v) => v.available);
      if (!checked) return null;
      return product.data.variants.find((v) => v.options[product.data.sizeIndex] === checked.value && v.available);
    }

    toggle(productId) {
      if (this.selection.some((item) => item.productId === productId)) {
        this.remove(productId, false);
        return;
      }
      const product = this.products.get(productId);
      const variant = this.selectedVariant(product);
      if (!variant) {
        this.announce(this.strings.chooseSize);
        product.card.querySelector('.hb-size input:not(:disabled)')?.focus();
        return;
      }
      if (this.selection.length >= this.size) {
        this.announce(this.format(this.strings.full, { total: this.size }));
        return;
      }
      const value = product.data.sizeIndex === -1 ? '' : variant.options[product.data.sizeIndex];
      this.selection.push({ productId, variant, value });
      this.announce(this.format(this.strings.added, {
        product: product.data.title, value, count: this.selection.length, total: this.size
      }));
      this.render();
    }

    remove(productId, fromTray) {
      const product = this.products.get(productId);
      this.selection = this.selection.filter((item) => item.productId !== productId);
      this.announce(this.format(this.strings.removed, { product: product.data.title }));
      this.render();
      if (fromTray) product.card.querySelector('[data-add]').focus();
    }

    render() {
      const full = this.selection.length >= this.size;
      this.products.forEach((product, productId) => {
        const inHamper = this.selection.some((item) => item.productId === productId);
        const button = product.card.querySelector('[data-add]');
        product.card.classList.toggle('is-selected', inHamper);
        button.textContent = inHamper ? this.strings.inHamper : this.strings.add;
        button.setAttribute('aria-pressed', inHamper ? 'true' : 'false');
        const canAdd = inHamper || (!full && this.selectedVariant(product));
        button.setAttribute('aria-disabled', canAdd ? 'false' : 'true');
      });

      const slots = this.querySelector('[data-slots]');
      slots.innerHTML = '';
      for (let i = 0; i < this.size; i += 1) {
        const item = this.selection[i];
        const li = document.createElement('li');
        if (!item) {
          li.className = 'hb-slot hb-slot--empty';
          li.textContent = this.format(this.strings.emptySlot, { number: i + 1 });
        } else {
          const { data } = this.products.get(item.productId);
          li.className = 'hb-slot';
          if (data.image) {
            const img = document.createElement('img');
            img.src = data.image;
            img.alt = '';
            img.width = 48;
            img.height = 60;
            img.loading = 'lazy';
            li.append(img);
          }
          const info = document.createElement('span');
          info.className = 'hb-slot__info';
          const title = document.createElement('span');
          title.className = 'hb-slot__title';
          title.textContent = data.title;
          const meta = document.createElement('span');
          meta.textContent = [item.value && `${this.strings.optionName} ${item.value}`, this.formatMoney(item.variant.price)]
            .filter(Boolean).join(' · ');
          info.append(title, meta);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'hb-slot__remove';
          remove.dataset.remove = item.productId;
          remove.setAttribute('aria-label', this.format(this.strings.remove, { product: data.title }));
          remove.textContent = '×';
          li.append(info, remove);
        }
        slots.append(li);
      }

      const progress = this.format(this.strings.progress, { count: this.selection.length, total: this.size });
      this.querySelector('[data-progress]').textContent = progress;
      const subtotal = this.selection.reduce((sum, item) => sum + item.variant.price, 0);
      const percent = parseFloat(this.dataset.discountPercent) || 0;
      const amount = parseInt(this.dataset.discountAmount, 10) || 0;
      let discount = 0;
      if (full) discount = amount > 0 ? Math.min(amount, subtotal) : Math.round((subtotal * percent) / 100);
      const box = this.querySelector('[data-gift-box]:checked');
      const total = subtotal - discount + (box && this.selection.length ? parseInt(box.dataset.price, 10) || 0 : 0);
      const subtotalEl = this.querySelector('[data-subtotal]');
      if (subtotalEl) {
        subtotalEl.textContent = this.selection.length ? this.formatMoney(subtotal) : '—';
        subtotalEl.classList.toggle('hb-tray__struck', discount > 0);
        this.querySelector('[data-discount]').textContent = full
          ? `−${this.formatMoney(discount)}`
          : this.format(this.strings.discountPending, { count: this.size });
      }
      this.querySelector('[data-total]').textContent = this.selection.length ? this.formatMoney(total) : '—';

      const submit = this.querySelector('[data-submit]');
      submit.setAttribute('aria-disabled', full && !this.submitting ? 'false' : 'true');
      const bar = this.querySelector('[data-bar]');
      bar.hidden = this.selection.length === 0;
      this.querySelector('[data-bar-progress]').textContent = `${progress} · ${this.selection.length ? this.formatMoney(total) : ''}`;
      if (this.previewDialog?.open) this.renderPreview();
    }

    // Hovering a card with a mouse steps through that product's photos.
    setupCycling() {
      this.querySelectorAll('.hb-card__preview').forEach((button) => {
        const images = button.querySelectorAll('.hb-card__img');
        const dots = button.querySelectorAll('.hb-card__dots span');
        if (images.length < 2) return;
        let index = 0;
        let timer = null;
        const show = (next) => {
          index = next % images.length;
          images.forEach((img, i) => img.classList.toggle('is-active', i === index));
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        };
        button.addEventListener('pointerenter', (evt) => {
          if (evt.pointerType !== 'mouse' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          button.classList.add('is-cycling');
          show(1);
          timer = window.setInterval(() => show(index + 1), 1100);
        });
        button.addEventListener('pointerleave', () => {
          window.clearInterval(timer);
          button.classList.remove('is-cycling');
          show(0);
        });
      });
    }

    setupPreview() {
      this.previewDialog = this.querySelector('[data-preview-dialog]');
      if (!this.previewDialog || typeof this.previewDialog.showModal !== 'function') return;
      const dialog = this.previewDialog;
      this.previewGallery = dialog.querySelector('gift-gallery');
      dialog.addEventListener('click', (evt) => {
        if (evt.target === dialog || evt.target.closest('[data-preview-close]')) {
          dialog.close();
          return;
        }
        if (evt.target.closest('[data-preview-add]')) this.addFromPreview();
      });
      dialog.addEventListener('change', (evt) => {
        if (!evt.target.matches('[data-preview-sizes] input')) return;
        const product = this.products.get(this.previewId);
        const cardInput = [...product.card.querySelectorAll('.hb-size input')].find((input) => input.value === evt.target.value);
        if (cardInput) {
          cardInput.checked = true;
          cardInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.previewMessage = '';
        this.renderPreview();
      });
    }

    openPreview(productId) {
      if (!this.previewDialog || typeof this.previewDialog.showModal !== 'function') {
        window.location.href = this.products.get(productId).data.url;
        return;
      }
      const { data } = this.products.get(productId);
      const dialog = this.previewDialog;
      this.previewId = productId;
      this.previewMessage = '';
      const images = data.images.length ? data.images : [data.image].filter(Boolean);

      this.previewGallery.setImages(images, data.title);

      dialog.querySelector('[data-preview-type]').textContent = data.type || '';
      dialog.querySelector('[data-preview-title]').textContent = data.title;
      dialog.querySelector('[data-preview-desc]').textContent = data.description || '';
      dialog.querySelector('[data-preview-link]').href = data.url;

      this.renderPreview();
      dialog.showModal();
      this.previewGallery.reset();
    }

    renderPreview() {
      const product = this.products.get(this.previewId);
      if (!product) return;
      const { data, card } = product;
      const dialog = this.previewDialog;
      const variant = this.selectedVariant(product);
      const prices = data.variants.map((v) => v.price);
      dialog.querySelector('[data-preview-price]').textContent = this.formatMoney(variant ? variant.price : Math.min(...prices));

      const list = dialog.querySelector('[data-preview-sizes]');
      const cardInputs = [...card.querySelectorAll('.hb-size input')];
      list.closest('fieldset').hidden = cardInputs.length === 0;
      list.replaceChildren(...cardInputs.map((cardInput) => {
        const label = document.createElement('label');
        label.className = 'hb-size';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = `gift-qv-${this.previewId}`;
        input.value = cardInput.value;
        input.checked = cardInput.checked;
        input.disabled = cardInput.disabled;
        const span = document.createElement('span');
        span.textContent = cardInput.value;
        label.append(input, span);
        return label;
      }));

      const inHamper = this.selection.some((item) => item.productId === this.previewId);
      const full = this.selection.length >= this.size;
      const add = dialog.querySelector('[data-preview-add]');
      add.textContent = inHamper ? this.strings.inHamper : this.strings.add;
      add.setAttribute('aria-pressed', inHamper ? 'true' : 'false');
      add.setAttribute('aria-disabled', inHamper || (!full && variant) ? 'false' : 'true');

      const progress = this.format(this.strings.progress, { count: this.selection.length, total: this.size });
      dialog.querySelector('[data-preview-status]').textContent = this.previewMessage
        || (inHamper || this.selection.length ? progress : '');
    }

    addFromPreview() {
      const product = this.products.get(this.previewId);
      const inHamper = this.selection.some((item) => item.productId === this.previewId);
      if (!inHamper && !this.selectedVariant(product)) {
        this.previewMessage = this.strings.chooseSize;
        this.renderPreview();
        this.previewDialog.querySelector('[data-preview-sizes] input:not(:disabled)')?.focus();
        return;
      }
      if (!inHamper && this.selection.length >= this.size) {
        this.previewMessage = this.format(this.strings.full, { total: this.size });
        this.renderPreview();
        return;
      }
      this.previewMessage = '';
      this.toggle(this.previewId);
    }

    announce(message) {
      const live = this.querySelector('[data-live]');
      live.textContent = '';
      window.setTimeout(() => { live.textContent = message; }, 50);
    }

    showError(message) {
      const error = this.querySelector('[data-error]');
      error.textContent = message || '';
      error.hidden = !message;
    }

    async submit() {
      const submit = this.querySelector('[data-submit]');
      if (this.submitting) return;
      if (this.selection.length < this.size) {
        this.showError(this.format(this.strings.needMore, { count: this.size - this.selection.length }));
        return;
      }
      this.submitting = true;
      this.showError('');
      submit.classList.add('is-loading');
      submit.setAttribute('aria-disabled', 'true');
      submit.textContent = this.strings.adding;

      this.hamperId = `BYO-${Date.now().toString(36).toUpperCase()}`;
      const label = `${this.dataset.hamperLabel} · ${this.hamperId}`;
      const sectionsToUpdate = ['page-header', 'cart-drawer']
        .map((selector) => document.querySelector(selector))
        .filter((el) => el && el.dataset.sectionId);
      const body = {
        items: this.selection.map((item) => ({
          id: item.variant.id,
          quantity: 1,
          properties: { [this.strings.property]: label, _gift_hamper_id: this.hamperId }
        })),
        sections: sectionsToUpdate.map((el) => el.dataset.sectionId).join(','),
        sections_url: window.location.pathname
      };
      // The paid gift box joins the hamper (same ID), so the cart shows it in the hamper's row.
      const box = this.querySelector('[data-gift-box]:checked');
      if (box) {
        body.items.push({
          id: Number(box.value),
          quantity: 1,
          properties: { [this.strings.property]: label, _gift_hamper_id: this.hamperId, _gift_box: '1' }
        });
      }

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || this.strings.error);

        if (window.theme && theme.settings.afterAddToCart === 'page') {
          window.location.href = theme.routes.cart;
          return;
        }
        if (data.sections) {
          sectionsToUpdate.forEach((el) => {
            const html = data.sections[el.dataset.sectionId];
            if (html && el.updateFromCartChange) el.updateFromCartChange(html);
          });
        }
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        this.announce(this.strings.addedToCart);
        this.selection = [];
        this.querySelectorAll('.hb-size input:checked').forEach((input) => { input.checked = false; });
        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer && drawer.open) drawer.open(submit);
      } catch (error) {
        this.showError(error.message || this.strings.error);
      } finally {
        this.submitting = false;
        submit.classList.remove('is-loading');
        submit.textContent = this.strings.addToCart;
        this.render();
      }
    }
  }

  if (!customElements.get('gift-hamper-builder')) {
    customElements.define('gift-hamper-builder', GiftHamperBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-page-nav"] && !Shopify.designMode) return;
  try {
    
  class GiftPageNav extends HTMLElement {
    connectedCallback() {
      const header = document.querySelector('.section-header');
      if (header && getComputedStyle(header).position === 'sticky') {
        this.style.setProperty('--gift-nav-offset', `${header.offsetHeight}px`);
      }
      this.links = [...this.querySelectorAll('.gift-nav__link')];
      const targets = this.links
        .map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))))
        .filter(Boolean);
      if (!targets.length || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.links.forEach((link) => {
            link.setAttribute('aria-current', link.hash === `#${entry.target.id}` ? 'true' : 'false');
          });
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      targets.forEach((target) => this.observer.observe(target));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('gift-page-nav')) {
    customElements.define('gift-page-nav', GiftPageNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-showcase"] && !Shopify.designMode) return;
  try {
    
  class GiftOfferQuickAdd extends HTMLElement {
    connectedCallback() {
      this.sizes = JSON.parse(this.querySelector('[data-sizes]').textContent || '{}');
      this.button = this.querySelector('[data-quick-add]');
      this.label = this.button.textContent.trim();
      this.addEventListener('change', () => {
        this.showError('');
        this.update();
      });
      this.button.addEventListener('click', () => this.submit());
      this.update();
    }

    selectedSize() {
      const checked = this.querySelector('.gift-offer__size input:checked');
      return checked ? checked.value : null;
    }

    update() {
      const ready = Boolean(this.sizes[this.selectedSize()]) && !this.submitting;
      this.button.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }

    announce(message) {
      const live = this.querySelector('[data-live]');
      live.textContent = '';
      window.setTimeout(() => { live.textContent = message; }, 50);
    }

    showError(message) {
      const error = this.querySelector('[data-error-message]');
      error.textContent = message || '';
      error.hidden = !message;
    }

    async submit() {
      if (this.submitting) return;
      const ids = this.sizes[this.selectedSize()];
      if (!ids) {
        this.showError(this.dataset.chooseSize);
        this.querySelector('.gift-offer__size input:not(:disabled)')?.focus();
        return;
      }
      this.submitting = true;
      this.showError('');
      this.update();
      this.button.classList.add('is-loading');
      this.button.textContent = this.dataset.adding;

      const hamperId = `GH-${Date.now().toString(36).toUpperCase()}`;
      const sectionsToUpdate = ['page-header', 'cart-drawer']
        .map((selector) => document.querySelector(selector))
        .filter((el) => el && el.dataset.sectionId);
      const hamperProperties = { [this.dataset.property]: `${this.dataset.hamperLabel} · ${hamperId}`, _gift_hamper_id: hamperId };
      const items = ids.map((id) => ({
        id,
        quantity: 1,
        // A bundle is one cart line already, so only the loose Trio needs the hamper label.
        ...(this.hasAttribute('data-bundle') ? {} : { properties: hamperProperties })
      }));
      // The paid gift box joins the hamper (same ID), so the cart shows it in the hamper's row.
      const box = this.querySelector('[data-gift-box]:checked');
      if (box) items.push({ id: Number(box.value), quantity: 1, properties: { ...hamperProperties, _gift_box: '1' } });
      const body = {
        items,
        sections: sectionsToUpdate.map((el) => el.dataset.sectionId).join(','),
        sections_url: window.location.pathname
      };

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || this.dataset.error);

        if (window.theme && theme.settings.afterAddToCart === 'page') {
          window.location.href = theme.routes.cart;
          return;
        }
        if (data.sections) {
          sectionsToUpdate.forEach((el) => {
            const html = data.sections[el.dataset.sectionId];
            if (html && el.updateFromCartChange) el.updateFromCartChange(html);
          });
        }
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        this.announce(this.dataset.added);
        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer && drawer.open) drawer.open(this.button);
      } catch (error) {
        this.showError(error.message || this.dataset.error);
      } finally {
        this.submitting = false;
        this.button.classList.remove('is-loading');
        this.button.textContent = this.label;
        this.update();
      }
    }
  }

  // Cards side by side get the same description height, so prices, sizes and buttons line up across a row.
  document.querySelectorAll('.gift-showcase').forEach((section) => {
    const texts = [...section.querySelectorAll('.gift-offer .gift-offer__text')];
    if (texts.length < 2) return;
    const align = () => {
      texts.forEach((text) => { text.style.minHeight = ''; });
      const rows = new Map();
      texts.forEach((text) => {
        const top = Math.round(text.closest('.gift-offer').getBoundingClientRect().top + window.scrollY);
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push(text);
      });
      rows.forEach((row) => {
        if (row.length < 2) return;
        const tallest = Math.max(...row.map((text) => text.offsetHeight));
        row.forEach((text) => { text.style.minHeight = `${tallest}px`; });
      });
    };
    let frame;
    const schedule = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(align);
    };
    // Only a width change can rewrap the text; reacting to height too would loop on our own min-height.
    let width = 0;
    new ResizeObserver(([entry]) => {
      if (Math.round(entry.contentRect.width) === width) return;
      width = Math.round(entry.contentRect.width);
      schedule();
    }).observe(section);
    document.fonts?.ready.then(schedule);
  });

  // Festive offer strip: days left until the countdown date, worked out in the visitor's browser so cached pages stay correct.
  document.querySelectorAll('.gift-showcase__countdown[data-countdown]').forEach((el) => {
    const [y, m, d] = el.dataset.countdown.split('-').map(Number);
    if (!y || !m || !d) return;
    const today = new Date();
    const days = Math.round((new Date(y, m - 1, d) - new Date(today.getFullYear(), today.getMonth(), today.getDate())) / 86400000);
    if (days < 1) return;
    el.textContent = el.dataset.label.replace('[days]', days).replace(/\bdays\b/, days === 1 ? 'day' : 'days');
    el.hidden = false;
  });

  if (!customElements.get('gift-offer-quick-add')) {
    customElements.define('gift-offer-quick-add', GiftOfferQuickAdd);
  }

  // Quick view for a curated hamper: its photos, what's inside, and a size picker that drives the card's own
  // quick add, so the card and the dialog always agree on the chosen size.
  class GiftHamperQuickView extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.section = this.closest('.gift-showcase');
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || !this.section) return;
      this.gallery = this.dialog.querySelector('gift-gallery');

      this.section.addEventListener('click', (evt) => {
        const trigger = evt.target.closest('[data-hamper-preview]');
        if (!trigger || this.dialog.contains(trigger) || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
        evt.preventDefault();
        this.open(trigger.closest('.gift-offer'));
      });
      this.dialog.addEventListener('click', (evt) => {
        if (evt.target === this.dialog || evt.target.closest('[data-qv-close]')) this.dialog.close();
        if (evt.target.closest('[data-qv-add]')) this.add();
      });
      this.dialog.addEventListener('change', (evt) => {
        if (!evt.target.matches('[data-qv-sizes] input')) return;
        const cardInput = [...this.quickAdd.querySelectorAll('.gift-offer__size input')].find((input) => input.value === evt.target.value);
        if (cardInput) {
          cardInput.checked = true;
          cardInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.status('');
      });
    }

    open(card) {
      const data = JSON.parse(card.querySelector('[data-hamper-json]').textContent);
      this.card = card;
      this.quickAdd = card.querySelector('gift-offer-quick-add');
      const title = card.querySelector('.gift-offer__title').textContent.trim();

      this.gallery.setImages(data.images, title);
      this.dialog.querySelector('[data-qv-eyebrow]').textContent = card.querySelector('.gift-offer__eyebrow')?.textContent || '';
      this.dialog.querySelector('[data-qv-title]').textContent = title;
      this.dialog.querySelector('[data-qv-text]').innerHTML = card.querySelector('.gift-offer__text')?.innerHTML || '';
      this.dialog.querySelector('[data-qv-price]').innerHTML = card.querySelector('.gift-offer__price')?.innerHTML || '';
      this.dialog.querySelector('[data-qv-inside]').textContent = card.querySelector('.gift-offer__inside summary')?.textContent.trim() || '';

      this.dialog.querySelector('[data-qv-items]').replaceChildren(...data.items.map((item) => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = item.url;
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.width = 44;
        img.height = 55;
        const text = document.createElement('span');
        const name = document.createElement('span');
        name.className = 'gift-qv__item-title';
        name.textContent = item.title;
        const type = document.createElement('span');
        type.className = 'gift-qv__item-type';
        type.textContent = item.type;
        text.append(name, type);
        const price = document.createElement('span');
        price.className = 'gift-qv__item-price';
        price.textContent = item.price;
        link.append(img, text, price);
        li.append(link);
        return li;
      }));

      this.dialog.querySelector('[data-qv-size-label]').textContent = card.querySelector('.gift-offer__sizes-label')?.textContent || '';
      this.dialog.querySelector('[data-qv-sizes]').replaceChildren(...[...this.quickAdd.querySelectorAll('.gift-offer__size input')].map((cardInput) => {
        const label = document.createElement('label');
        label.className = 'gift-offer__size';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'gift-qv-size';
        input.value = cardInput.value;
        input.checked = cardInput.checked;
        input.disabled = cardInput.disabled;
        const span = document.createElement('span');
        span.textContent = cardInput.value;
        label.append(input, span);
        return label;
      }));
      const cardBox = this.quickAdd.querySelector('.gift-box-option');
      const boxSlot = this.dialog.querySelector('[data-qv-box]');
      boxSlot.replaceChildren();
      if (cardBox) {
        const box = cardBox.cloneNode(true);
        const cardInput = cardBox.querySelector('[data-gift-box]');
        const input = box.querySelector('[data-gift-box]');
        input.checked = cardInput.checked;
        input.addEventListener('change', () => { cardInput.checked = input.checked; });
        boxSlot.append(box);
      }
      boxSlot.hidden = !cardBox;
      this.dialog.querySelector('[data-qv-add]').textContent = this.quickAdd.querySelector('[data-quick-add]').textContent.trim();
      this.status('');

      this.dialog.showModal();
      this.gallery.reset();
    }

    status(message) {
      this.dialog.querySelector('[data-qv-status]').textContent = message;
    }

    async add() {
      const button = this.dialog.querySelector('[data-qv-add]');
      if (button.getAttribute('aria-busy') === 'true') return;
      if (!this.dialog.querySelector('[data-qv-sizes] input:checked')) {
        this.status(this.quickAdd.dataset.chooseSize);
        this.dialog.querySelector('[data-qv-sizes] input:not(:disabled)')?.focus();
        return;
      }
      const label = button.textContent;
      button.setAttribute('aria-busy', 'true');
      button.textContent = this.quickAdd.dataset.adding;
      await this.quickAdd.submit();
      button.removeAttribute('aria-busy');
      button.textContent = label;
      const error = this.quickAdd.querySelector('[data-error-message]');
      if (error && !error.hidden && error.textContent) {
        this.status(error.textContent);
        return;
      }
      this.dialog.close();
    }
  }

  if (!customElements.get('gift-hamper-quick-view')) {
    customElements.define('gift-hamper-quick-view', GiftHamperQuickView);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
